<script land="ts" setup>
import { ref, computed, inject } from "vue";
import RothcoTable from "@/components/RothcoTable.vue";
import RothcoCta from "@/components/RothcoCta.vue"
import { router, } from "@inertiajs/vue3";
import { useDateFormat } from "@vueuse/core";
import { useRouter } from "@/helpers/composables/useRouter";
import { formatPriceAsString } from "@/helpers/composables/usePriceFormatting"
import DatePicker from "@/components/DatePicker.vue";
    const props = defineProps({
        payments: {
            type: Object,
            default() {
                return {
                    data: [],
                    meta: {
                        total: 0,
                        current_page: 1,
                        per_page: 10,
                        last_page: 1
                    }
                };
            }
        }
    })

    let route = inject("route");

    const tableContent = computed(()=>{
        return props.payments.data.map(item=>{
            return {
                data: {
                    ...item,
                    'amount': `${formatPriceAsString(item?.amount)}`,
                    'paid_at': useDateFormat(item.transaction_date, "MM-DD-YYYY")?.value ?? '',
                }
            }
        });
    });

    const paymentCount = computed(()=>{
        return props.payments?.meta?.total ?? null;
    })

    const backendPagination = computed(()=>{
        return {
            ...props.payments.links,
            ...props.payments.meta,
        }
    })

    let focused = ref(false);

    let visibleFields = computed(()=>{
        return [
            { 
                label: "Payment Type", 
                field: "payment_method",
                pt: {
                    bodyCell: { class: 'mob-w-50 text-left', 'data-label': "Payment Type" }
                } 
            },
            { 
                label: "Name", 
                field: "name",
                pt: {
                    bodyCell: { class: 'mob-w-50 text-left', 'data-label': "Name" }
                } 
            },
            { 
                label: "Amount", 
                field: "amount", 
                sortable: true,
                pt: {
                    headerCell: { class: 'title-xs text-right'},
                    bodyCell: { class: 'mob-w-50', 'data-label': "Amount" },
                    bodyCellContent: { class: 'desk-text-right' }
                } 
            },
            { 
                label: "Transaction Date", 
                field: "paid_at", 
                sortable: true,
                pt: {
                    bodyCell: { class: 'mob-w-50 text-left', 'data-label': "Date" }
                }
            },
            
        ];
    })
    const urlParams = new URLSearchParams(window.location.search);
    let paidAtParams = urlParams.get('range[paid_at]')?.split(',');
    if(paidAtParams){
        paidAtParams = paidAtParams.map(date=>{
            return new Date(date);
        });
    }
    let dateRange = ref(paidAtParams ?? []);

    const currentFilters = computed(() => {
        let dateFilters;
        if (Array.isArray(dateRange.value) && dateRange.value.length > 1) {
            dateFilters =
                `${dateRange.value[0] ? useDateFormat(dateRange.value[0], "YYYY-MM-DD 00:00:00").value : ""},` +
                `${dateRange.value[1] ? useDateFormat(dateRange.value[1], "YYYY-MM-DD 23:59:59").value : ""}`;
        }
        return {
            ...(dateFilters && {
                "range[paid_at]": dateFilters
            }),
        };
    });

    let { to } = useRouter({
        router,
        route
    });

    const sortTable = ($event)=>{
        to({ newParams: { orderBy: `${$event.key}:${$event.direction}` }, options: {preserveState: true, preserveScroll: true}});
    }
</script>
<template>
        <div class="account-page-padding">
            <div class="payment-history">
                <div class="header">
                    <h1>Payment History</h1>
                    <h3 id="paymentsCount" v-if="paymentCount !== null">{{ paymentCount }} payments</h3>
                </div>
                <p style="padding-bottom: 1rem;">
                    Rothco's online credit card payment history will allow
                    you to view any payments that have been made against the
                    credit cards on file. Note this screen ONLY shows credit
                    card payment and not all transaction history for other
                    payment types such as net terms and COD, etc.
                </p>
                <form>
                    <div class="search-fields">
                        <date-picker range label="Date Picker" name="payment_history_date_range" v-model="dateRange"  aria-label="Date Range"/>
                        <div class="buttons">
                            <RothcoCta
                                class="payment-history-button" 
                                id="submit_button"
                                type="submit"
                                :button_icon="null"
                                :href="route('account.paymentHistory')"
                                :data="currentFilters"
                                preserve-state
                                preserve-scroll
                                :only="['payments']">
                                Search
                            </RothcoCta>
                        </div>
                    </div>
                </form>
                <rothco-table
                    id="paymentHistoryTable"
                    key="table"
                    v-model:focused="focused"
                    v-model:content="tableContent"
                    :visible-fields="visibleFields"
                    :backendPagination="backendPagination"
                    :useBackendSorting="true"
                    @sort="sortTable"
                    primary-key="order_id"
                    focusable
                >

                </rothco-table>
            </div>
        </div>
</template>
